const trimTrailingSlashes = (value = "") => value.replace(/\/+$/, "");

export const SITE_URL = trimTrailingSlashes(import.meta.env.VITE_SITE_URL || "http://localhost:8989");
export const API_BASE_URL = `${SITE_URL}/api`;
